var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLikeFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#292A2E",
  d: "M1.856 9.942h3.166V20.88H1.856a.85.85 0 0 1-.605-.253.87.87 0 0 1-.251-.613v-9.206c0-.23.09-.45.25-.613a.85.85 0 0 1 .606-.253M5.913 9.941l4.349-7.038c.168-.278.405-.508.687-.666s.6-.239.922-.236a1.88 1.88 0 0 1 1.382.533 1.93 1.93 0 0 1 .587 1.374v5.045h7.515a1.95 1.95 0 0 1 1.449.716 2 2 0 0 1 .434 1.572l-1.37 8.945a1.98 1.98 0 0 1-.643 1.238c-.356.319-.815.495-1.29.496H8.703a3.4 3.4 0 0 1-1.541-.364l-1.233-.624"
})));
export default SvgLikeFill;